// Thin HTTP wrappers for named, reusable Fleet Query connection presets
// (per-user). A preset is { id, name, pairs:[{connectionId, database}], ... }.
import { api } from './api.js';

export async function listFleetPresets() {
  return (await api.get('/api/me/fleet-presets')).presets || [];
}

// Create or update by name (server upserts) → the stored preset.
export async function saveFleetPreset(name, pairs) {
  return (await api.post('/api/me/fleet-presets', { name, pairs })).preset;
}

// Rewrite an existing preset by id (rename and/or change its pairs).
export async function updateFleetPreset(id, name, pairs) {
  return api.put(`/api/me/fleet-presets/${id}`, { name, pairs });
}

export async function deleteFleetPreset(id) {
  return api.delete(`/api/me/fleet-presets/${id}`);
}
